import { DataRole, DataType, DateTime } from '@mode-switch/express';
import { Attr } from '@mode-switch/model';

import { FlamingoTypes } from '@mode/shared/contract-common';

import {
  makeDatePartQuarterName,
  makeDatePartMonthName,
  makeDatePartWeekdayName,
  makeDatePartHourName,
  makeDatePartMinuteName,
  makeDatePartSecondName,
} from './chart-date';

export type SummaryValueFormatter = (name: any) => string;

export function makeSummaryValueFormatter(field: FlamingoTypes.ModeField): SummaryValueFormatter {
  if (field.formula.role?.name === DataRole.Name.DatePart) {
    return makeDatePartValueFormatter(field, field.formula.role);
  }

  switch (field.formula.type.name) {
    case DataType.Name.DateTime:
    case DataType.Name.Timestamp:
    case DataType.Name.Decimal:
    case DataType.Name.Integer:
    case DataType.Name.Float:
    case DataType.Name.Boolean:
      return (name: any) => name;
    default:
      return (name: any) => (name == null ? null : name.toString());
  }
}

export function makeDatePartValueFormatter(
  field: FlamingoTypes.ModeField,
  role: DataRole.DatePart
): SummaryValueFormatter {
  return (name: any) => {
    switch (field.type) {
      case Attr.Type.Discrete:
        return name == null ? null : makeDatePartName(role, name);
      case Attr.Type.Continuous:
        return name == null ? null : name;
    }
  };
}

export function makeDatePartName(role: DataRole.DatePart, value: any): string {
  switch (role.unit) {
    case DateTime.Unit.Quarter:
      return makeDatePartQuarterName(value);
    case DateTime.Unit.Month:
      return makeDatePartMonthName(value);
    case DateTime.Unit.Weekday:
      return makeDatePartWeekdayName(value);
    case DateTime.Unit.Hour:
      return makeDatePartHourName(value);
    case DateTime.Unit.Minute:
      return makeDatePartMinuteName(value);
    case DateTime.Unit.Second:
      return makeDatePartSecondName(value);
  }

  return value == null ? value : value.toString();
}
